import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import NewReleasesIcon from '@mui/icons-material/NewReleases';
import { styled } from '@mui/material/styles';
//
import { Linkify } from '/@/app/linkify';
import { AudioPlayer } from '/@/app/components/AudioPlayer';


const Item = styled(Box)(({ theme }) => ({
    backgroundColor: '#f5f7fb',
    ...theme.typography.body2,

    borderRadius: theme.shape.borderRadius * 1.5,
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(3),
    },
    [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(4.5),
    },
    //
    textAlign: "left",
    color: theme.palette.text.primary,
}));


export const RiskItem = ({ risk }) => {
    const { t } = useTranslation();

    return (
        <Item sx={{position: "relative"}}>
            <AudioPlayer
                audioSrc={risk.sound_link} sx={{ position: "absolute", top: "10px", right: "10px" }}
                size="25px"
                hideCaption={true}
            />
            {risk.years_lost ?
                <Typography variant="h5" component="h3" gutterBottom sx={{
                    textAlign: "center",
                    marginBottom: theme => theme.spacing(2),
                }}>
                    {t("лет жизни", { count: Math.round(risk.years_lost*10, 1)/10 })}
                </Typography>
                : null
            }
            <Typography variant="h6" component="h4" gutterBottom sx={{
                color: "black",
                fontWeight: "normal",
                lineHeight: "1.25",  // 1.25 seems visually good for multiline header
                marginBottom: "15px",
            }}>
                <Linkify text={risk.short_description} />
            </Typography>
            <Typography variant="body1" gutterBottom>
                <Linkify text={risk.description} />
            </Typography>

            {risk.details && risk.details.slice(0,4) === "http" ?  // FIXME normalize link on backend
                <Typography variant="body1" gutterBottom>
                    <Link href={risk.details} target="_blank" sx={{ display: "flex", flexFlow: "row nowrap", alignItems: "center" }}>
                        <NewReleasesIcon sx={{ mr: 1 }}/> {t("Обязательно прочитайте об этом риске!")}
                    </Link>
                </Typography>
                : null
            }
        </Item>
    )
};
